export default __webpack_public_path__ + "static/media/org-icon.a94214db.svg";